import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IDebugState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const debugModule: Module<IDebugState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default debugModule
